export default __webpack_public_path__ + "static/media/blue-hoodie-model.260e7cf7.jpg";